import styled from "@xstyled/styled-components";

import { Button, Middle } from "@otta/design";
import { palette } from "@otta/design-tokens";

const ButtonWrapper = styled.div`
  display: flex;
`;

const StyledButton = styled(Button)`
  flex: 1;
  margin-right: lg;

  &:last-of-type {
    margin-right: 0;
  }
`;

const Bar = styled.div`
  z-index: 1;
  width: 100%;
  padding: md;
  background-color: white;
  border-top: 1px solid ${palette.grayscale.shade200};
`;

interface IBottomButtonBarProps {
  handlePositive: React.MouseEventHandler<HTMLButtonElement>;
  handleNegative: React.MouseEventHandler<HTMLButtonElement>;
  showNegative: boolean;
  showPositive?: boolean;
  nextEnabled: boolean;
  positiveText: string;
}

export function BottomButtonBar({
  showNegative,
  showPositive = true,
  nextEnabled,
  handleNegative,
  handlePositive,
  positiveText,
}: IBottomButtonBarProps): React.ReactElement {
  return (
    <Bar>
      <Middle maxWidth={480}>
        <ButtonWrapper>
          {showNegative && (
            <StyledButton level="secondary" onClick={handleNegative}>
              Back
            </StyledButton>
          )}
          {showPositive && (
            <StyledButton
              level="primary"
              disabled={!nextEnabled}
              onClick={handlePositive}
            >
              {positiveText}
            </StyledButton>
          )}
        </ButtonWrapper>
      </Middle>
    </Bar>
  );
}
